export default __webpack_public_path__ + "static/media/dimmer.019affd3.png";